// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file daemon/v1alpha/daemon.proto (package com.seed.daemon.v1alpha, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";

/**
 * State describes various states of the daemon.
 *
 * @generated from enum com.seed.daemon.v1alpha.State
 */
export enum State {
  /**
   * Daemon in starting up and it not ready to use yet.
   *
   * @generated from enum value: STARTING = 0;
   */
  STARTING = 0,

  /**
   * Daemon is running a data migration, which may take a while.
   * Callers should poll and wait until the daemon becomes ACTIVE.
   *
   * @generated from enum value: MIGRATING = 1;
   */
  MIGRATING = 1,

  /**
   * Daemon is active and ready to use.
   *
   * @generated from enum value: ACTIVE = 3;
   */
  ACTIVE = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(State)
proto3.util.setEnumType(State, "com.seed.daemon.v1alpha.State", [
  { no: 0, name: "STARTING" },
  { no: 1, name: "MIGRATING" },
  { no: 3, name: "ACTIVE" },
]);

/**
 * VaultBackendMode describes the daemon vault backend mode.
 *
 * @generated from enum com.seed.daemon.v1alpha.VaultBackendMode
 */
export enum VaultBackendMode {
  /**
   * Unknown backend mode.
   *
   * @generated from enum value: VAULT_BACKEND_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Local encrypted vault file only.
   *
   * @generated from enum value: VAULT_BACKEND_MODE_LOCAL = 1;
   */
  LOCAL = 1,

  /**
   * Local encrypted vault file with remote sync enabled.
   *
   * @generated from enum value: VAULT_BACKEND_MODE_REMOTE = 2;
   */
  REMOTE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(VaultBackendMode)
proto3.util.setEnumType(VaultBackendMode, "com.seed.daemon.v1alpha.VaultBackendMode", [
  { no: 0, name: "VAULT_BACKEND_MODE_UNSPECIFIED" },
  { no: 1, name: "VAULT_BACKEND_MODE_LOCAL" },
  { no: 2, name: "VAULT_BACKEND_MODE_REMOTE" },
]);

/**
 * VaultConnectionStatus describes remote connection status for daemon vault sync.
 *
 * @generated from enum com.seed.daemon.v1alpha.VaultConnectionStatus
 */
export enum VaultConnectionStatus {
  /**
   * Unknown connection status.
   *
   * @generated from enum value: VAULT_CONNECTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Remote vault sync is not connected.
   *
   * @generated from enum value: VAULT_CONNECTION_STATUS_DISCONNECTED = 1;
   */
  DISCONNECTED = 1,

  /**
   * Remote vault sync is connected.
   *
   * @generated from enum value: VAULT_CONNECTION_STATUS_CONNECTED = 2;
   */
  CONNECTED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(VaultConnectionStatus)
proto3.util.setEnumType(VaultConnectionStatus, "com.seed.daemon.v1alpha.VaultConnectionStatus", [
  { no: 0, name: "VAULT_CONNECTION_STATUS_UNSPECIFIED" },
  { no: 1, name: "VAULT_CONNECTION_STATUS_DISCONNECTED" },
  { no: 2, name: "VAULT_CONNECTION_STATUS_CONNECTED" },
]);

/**
 * Different types of tasks that the daemon can perform.
 *
 * @generated from enum com.seed.daemon.v1alpha.TaskName
 */
export enum TaskName {
  /**
   * Unknown task.
   *
   * @generated from enum value: TASK_NAME_UNSPECIFIED = 0;
   */
  TASK_NAME_UNSPECIFIED = 0,

  /**
   * Task for reindexing the database.
   *
   * @generated from enum value: REINDEXING = 1;
   */
  REINDEXING = 1,

  /**
   * Task for generating embeddings.
   *
   * @generated from enum value: EMBEDDING = 2;
   */
  EMBEDDING = 2,

  /**
   * Task for loading a machine learning model.
   *
   * @generated from enum value: LOADING_MODEL = 3;
   */
  LOADING_MODEL = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(TaskName)
proto3.util.setEnumType(TaskName, "com.seed.daemon.v1alpha.TaskName", [
  { no: 0, name: "TASK_NAME_UNSPECIFIED" },
  { no: 1, name: "REINDEXING" },
  { no: 2, name: "EMBEDDING" },
  { no: 3, name: "LOADING_MODEL" },
]);

/**
 * Request to generate mnemonic words.
 *
 * @generated from message com.seed.daemon.v1alpha.GenMnemonicRequest
 */
export class GenMnemonicRequest extends Message<GenMnemonicRequest> {
  /**
   * Optional. Number of mnemonic words to encode the seed.
   * Usually 12 or 24 words.
   * By default 12 words are generated.
   *
   * @generated from field: int32 word_count = 1;
   */
  wordCount = 0;

  constructor(data?: PartialMessage<GenMnemonicRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.GenMnemonicRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "word_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenMnemonicRequest {
    return new GenMnemonicRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenMnemonicRequest {
    return new GenMnemonicRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenMnemonicRequest {
    return new GenMnemonicRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GenMnemonicRequest | PlainMessage<GenMnemonicRequest> | undefined, b: GenMnemonicRequest | PlainMessage<GenMnemonicRequest> | undefined): boolean {
    return proto3.util.equals(GenMnemonicRequest, a, b);
  }
}

/**
 * Response with the generated mnemonic.
 *
 * @generated from message com.seed.daemon.v1alpha.GenMnemonicResponse
 */
export class GenMnemonicResponse extends Message<GenMnemonicResponse> {
  /**
   * The list of human-friendly words that can be used to backup the seed. These
   * words must be stored in a secret place by the user.
   *
   * @generated from field: repeated string mnemonic = 1;
   */
  mnemonic: string[] = [];

  constructor(data?: PartialMessage<GenMnemonicResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.GenMnemonicResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "mnemonic", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenMnemonicResponse {
    return new GenMnemonicResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenMnemonicResponse {
    return new GenMnemonicResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenMnemonicResponse {
    return new GenMnemonicResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GenMnemonicResponse | PlainMessage<GenMnemonicResponse> | undefined, b: GenMnemonicResponse | PlainMessage<GenMnemonicResponse> | undefined): boolean {
    return proto3.util.equals(GenMnemonicResponse, a, b);
  }
}

/**
 * Request to authenticate a caller key.
 *
 * @generated from message com.seed.daemon.v1alpha.AuthenticateRequest
 */
export class AuthenticateRequest extends Message<AuthenticateRequest> {
  /**
   * Required. Bytes of the caller key that's being authenticated.
   *
   * @generated from field: bytes account = 1;
   */
  account = new Uint8Array(0);

  /**
   * Required. Timestamp of the request in Unix milliseconds. The daemon will check that it's not too old.
   *
   * @generated from field: int64 timestamp = 2;
   */
  timestamp = protoInt64.zero;

  /**
   * Required. Signature by the caller key over the authentication payload.
   * It signs over the account ID being proven, the account ID as the request delegate,
   * the daemon peer ID as the audience, and the timestamp.
   *
   * @generated from field: bytes signature = 3;
   */
  signature = new Uint8Array(0);

  constructor(data?: PartialMessage<AuthenticateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.AuthenticateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "timestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "signature", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AuthenticateRequest {
    return new AuthenticateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AuthenticateRequest {
    return new AuthenticateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AuthenticateRequest {
    return new AuthenticateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AuthenticateRequest | PlainMessage<AuthenticateRequest> | undefined, b: AuthenticateRequest | PlainMessage<AuthenticateRequest> | undefined): boolean {
    return proto3.util.equals(AuthenticateRequest, a, b);
  }
}

/**
 * Response to authenticate a caller key.
 *
 * @generated from message com.seed.daemon.v1alpha.AuthenticateResponse
 */
export class AuthenticateResponse extends Message<AuthenticateResponse> {
  /**
   * Opaque daemon bearer token.
   *
   * @generated from field: string bearer_token = 1;
   */
  bearerToken = "";

  /**
   * Time when the bearer token expires.
   *
   * @generated from field: google.protobuf.Timestamp expire_time = 2;
   */
  expireTime?: Timestamp;

  constructor(data?: PartialMessage<AuthenticateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.AuthenticateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expire_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AuthenticateResponse {
    return new AuthenticateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AuthenticateResponse {
    return new AuthenticateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AuthenticateResponse {
    return new AuthenticateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AuthenticateResponse | PlainMessage<AuthenticateResponse> | undefined, b: AuthenticateResponse | PlainMessage<AuthenticateResponse> | undefined): boolean {
    return proto3.util.equals(AuthenticateResponse, a, b);
  }
}

/**
 * Request to register a new account key derived from the mnemonic.
 *
 * @generated from message com.seed.daemon.v1alpha.RegisterKeyRequest
 */
export class RegisterKeyRequest extends Message<RegisterKeyRequest> {
  /**
   * Required. The list of BIP-39 mnemonic words.
   *
   * @generated from field: repeated string mnemonic = 1;
   */
  mnemonic: string[] = [];

  /**
   * Optional. Passphrase for the seed.
   *
   * @generated from field: string passphrase = 2;
   */
  passphrase = "";

  /**
   * Required. Private name/label for the signing key, to easily identify keys when they are more than one.
   * Name must be unique across all the registered keys.
   *
   * @generated from field: string name = 3;
   */
  name = "";

  constructor(data?: PartialMessage<RegisterKeyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.RegisterKeyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "mnemonic", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "passphrase", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RegisterKeyRequest {
    return new RegisterKeyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RegisterKeyRequest {
    return new RegisterKeyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RegisterKeyRequest {
    return new RegisterKeyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RegisterKeyRequest | PlainMessage<RegisterKeyRequest> | undefined, b: RegisterKeyRequest | PlainMessage<RegisterKeyRequest> | undefined): boolean {
    return proto3.util.equals(RegisterKeyRequest, a, b);
  }
}

/**
 * Request to import an existing account key from a .hmkey.json file path.
 *
 * @generated from message com.seed.daemon.v1alpha.ImportKeyRequest
 */
export class ImportKeyRequest extends Message<ImportKeyRequest> {
  /**
   * Required. Absolute path to a .hmkey.json key export file.
   *
   * @generated from field: string file_path = 1;
   */
  filePath = "";

  /**
   * Optional. Password to decrypt encrypted key exports.
   *
   * @generated from field: string password = 2;
   */
  password = "";

  constructor(data?: PartialMessage<ImportKeyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.ImportKeyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportKeyRequest {
    return new ImportKeyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportKeyRequest {
    return new ImportKeyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportKeyRequest {
    return new ImportKeyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ImportKeyRequest | PlainMessage<ImportKeyRequest> | undefined, b: ImportKeyRequest | PlainMessage<ImportKeyRequest> | undefined): boolean {
    return proto3.util.equals(ImportKeyRequest, a, b);
  }
}

/**
 * Request to export an existing account key to a .hmkey.json file path.
 *
 * @generated from message com.seed.daemon.v1alpha.ExportKeyRequest
 */
export class ExportKeyRequest extends Message<ExportKeyRequest> {
  /**
   * Required. Name of the key to export.
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * Required. Absolute path to a .hmkey.json key export file.
   *
   * @generated from field: string file_path = 2;
   */
  filePath = "";

  /**
   * Optional. Password to encrypt the exported key file.
   *
   * @generated from field: string password = 3;
   */
  password = "";

  constructor(data?: PartialMessage<ExportKeyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.ExportKeyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExportKeyRequest {
    return new ExportKeyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExportKeyRequest {
    return new ExportKeyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExportKeyRequest {
    return new ExportKeyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ExportKeyRequest | PlainMessage<ExportKeyRequest> | undefined, b: ExportKeyRequest | PlainMessage<ExportKeyRequest> | undefined): boolean {
    return proto3.util.equals(ExportKeyRequest, a, b);
  }
}

/**
 * Request to get basic information about the running daemon.
 *
 * @generated from message com.seed.daemon.v1alpha.GetInfoRequest
 */
export class GetInfoRequest extends Message<GetInfoRequest> {
  constructor(data?: PartialMessage<GetInfoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.GetInfoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetInfoRequest {
    return new GetInfoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetInfoRequest {
    return new GetInfoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetInfoRequest {
    return new GetInfoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetInfoRequest | PlainMessage<GetInfoRequest> | undefined, b: GetInfoRequest | PlainMessage<GetInfoRequest> | undefined): boolean {
    return proto3.util.equals(GetInfoRequest, a, b);
  }
}

/**
 * Request to get vault backend and sync status.
 *
 * @generated from message com.seed.daemon.v1alpha.GetVaultStatusRequest
 */
export class GetVaultStatusRequest extends Message<GetVaultStatusRequest> {
  /**
   * Optional. When true, forces an immediate sync with the remote vault.
   * Returns an error if the remote vault is not configured or offline.
   *
   * @generated from field: bool force_sync = 1;
   */
  forceSync = false;

  constructor(data?: PartialMessage<GetVaultStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.GetVaultStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "force_sync", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetVaultStatusRequest {
    return new GetVaultStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetVaultStatusRequest {
    return new GetVaultStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetVaultStatusRequest {
    return new GetVaultStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetVaultStatusRequest | PlainMessage<GetVaultStatusRequest> | undefined, b: GetVaultStatusRequest | PlainMessage<GetVaultStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetVaultStatusRequest, a, b);
  }
}

/**
 * Request to start remote vault connection.
 *
 * @generated from message com.seed.daemon.v1alpha.StartVaultConnectionRequest
 */
export class StartVaultConnectionRequest extends Message<StartVaultConnectionRequest> {
  /**
   * Required. Remote vault base URL.
   *
   * @generated from field: string vault_url = 1;
   */
  vaultUrl = "";

  /**
   * Optional. Force replacing active or already-connected state.
   *
   * @generated from field: bool force = 2;
   */
  force = false;

  constructor(data?: PartialMessage<StartVaultConnectionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.StartVaultConnectionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "vault_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "force", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartVaultConnectionRequest {
    return new StartVaultConnectionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartVaultConnectionRequest {
    return new StartVaultConnectionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartVaultConnectionRequest {
    return new StartVaultConnectionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StartVaultConnectionRequest | PlainMessage<StartVaultConnectionRequest> | undefined, b: StartVaultConnectionRequest | PlainMessage<StartVaultConnectionRequest> | undefined): boolean {
    return proto3.util.equals(StartVaultConnectionRequest, a, b);
  }
}

/**
 * Response with daemon-issued connect token metadata.
 *
 * @generated from message com.seed.daemon.v1alpha.StartVaultConnectionResponse
 */
export class StartVaultConnectionResponse extends Message<StartVaultConnectionResponse> {
  /**
   * Normalized remote vault base URL.
   *
   * @generated from field: string vault_url = 1;
   */
  vaultUrl = "";

  /**
   * Ephemeral connect token for browser-mediated daemon exchange.
   *
   * @generated from field: string connect_token = 2;
   */
  connectToken = "";

  /**
   * Connect token expiration time.
   *
   * @generated from field: google.protobuf.Timestamp expire_time = 3;
   */
  expireTime?: Timestamp;

  constructor(data?: PartialMessage<StartVaultConnectionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.StartVaultConnectionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "vault_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "connect_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expire_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartVaultConnectionResponse {
    return new StartVaultConnectionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartVaultConnectionResponse {
    return new StartVaultConnectionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartVaultConnectionResponse {
    return new StartVaultConnectionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StartVaultConnectionResponse | PlainMessage<StartVaultConnectionResponse> | undefined, b: StartVaultConnectionResponse | PlainMessage<StartVaultConnectionResponse> | undefined): boolean {
    return proto3.util.equals(StartVaultConnectionResponse, a, b);
  }
}

/**
 * Request to disconnect remote vault mode.
 *
 * @generated from message com.seed.daemon.v1alpha.DisconnectVaultRequest
 */
export class DisconnectVaultRequest extends Message<DisconnectVaultRequest> {
  /**
   * Optional. When true, clears local vault state after disconnecting without
   * recording account delete tombstones.
   *
   * @generated from field: bool clear_local_vault = 1;
   */
  clearLocalVault = false;

  constructor(data?: PartialMessage<DisconnectVaultRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.DisconnectVaultRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "clear_local_vault", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DisconnectVaultRequest {
    return new DisconnectVaultRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DisconnectVaultRequest {
    return new DisconnectVaultRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DisconnectVaultRequest {
    return new DisconnectVaultRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DisconnectVaultRequest | PlainMessage<DisconnectVaultRequest> | undefined, b: DisconnectVaultRequest | PlainMessage<DisconnectVaultRequest> | undefined): boolean {
    return proto3.util.equals(DisconnectVaultRequest, a, b);
  }
}

/**
 * Request to force the syncing process.
 *
 * @generated from message com.seed.daemon.v1alpha.ForceSyncRequest
 */
export class ForceSyncRequest extends Message<ForceSyncRequest> {
  constructor(data?: PartialMessage<ForceSyncRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.ForceSyncRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ForceSyncRequest {
    return new ForceSyncRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ForceSyncRequest {
    return new ForceSyncRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ForceSyncRequest {
    return new ForceSyncRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ForceSyncRequest | PlainMessage<ForceSyncRequest> | undefined, b: ForceSyncRequest | PlainMessage<ForceSyncRequest> | undefined): boolean {
    return proto3.util.equals(ForceSyncRequest, a, b);
  }
}

/**
 * Request to force reindexing of the entire database.
 *
 * @generated from message com.seed.daemon.v1alpha.ForceReindexRequest
 */
export class ForceReindexRequest extends Message<ForceReindexRequest> {
  constructor(data?: PartialMessage<ForceReindexRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.ForceReindexRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ForceReindexRequest {
    return new ForceReindexRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ForceReindexRequest {
    return new ForceReindexRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ForceReindexRequest {
    return new ForceReindexRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ForceReindexRequest | PlainMessage<ForceReindexRequest> | undefined, b: ForceReindexRequest | PlainMessage<ForceReindexRequest> | undefined): boolean {
    return proto3.util.equals(ForceReindexRequest, a, b);
  }
}

/**
 * Response after forcing reindexing.
 *
 * @generated from message com.seed.daemon.v1alpha.ForceReindexResponse
 */
export class ForceReindexResponse extends Message<ForceReindexResponse> {
  constructor(data?: PartialMessage<ForceReindexResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.ForceReindexResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ForceReindexResponse {
    return new ForceReindexResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ForceReindexResponse {
    return new ForceReindexResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ForceReindexResponse {
    return new ForceReindexResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ForceReindexResponse | PlainMessage<ForceReindexResponse> | undefined, b: ForceReindexResponse | PlainMessage<ForceReindexResponse> | undefined): boolean {
    return proto3.util.equals(ForceReindexResponse, a, b);
  }
}

/**
 * Request to delete all keys.
 *
 * @generated from message com.seed.daemon.v1alpha.DeleteAllKeysRequest
 */
export class DeleteAllKeysRequest extends Message<DeleteAllKeysRequest> {
  constructor(data?: PartialMessage<DeleteAllKeysRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.DeleteAllKeysRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAllKeysRequest {
    return new DeleteAllKeysRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAllKeysRequest {
    return new DeleteAllKeysRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAllKeysRequest {
    return new DeleteAllKeysRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAllKeysRequest | PlainMessage<DeleteAllKeysRequest> | undefined, b: DeleteAllKeysRequest | PlainMessage<DeleteAllKeysRequest> | undefined): boolean {
    return proto3.util.equals(DeleteAllKeysRequest, a, b);
  }
}

/**
 * Request to list signing keys.
 *
 * @generated from message com.seed.daemon.v1alpha.ListKeysRequest
 */
export class ListKeysRequest extends Message<ListKeysRequest> {
  constructor(data?: PartialMessage<ListKeysRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.ListKeysRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListKeysRequest {
    return new ListKeysRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListKeysRequest {
    return new ListKeysRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListKeysRequest {
    return new ListKeysRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListKeysRequest | PlainMessage<ListKeysRequest> | undefined, b: ListKeysRequest | PlainMessage<ListKeysRequest> | undefined): boolean {
    return proto3.util.equals(ListKeysRequest, a, b);
  }
}

/**
 * Response with the list of registered signing keys.
 *
 * @generated from message com.seed.daemon.v1alpha.ListKeysResponse
 */
export class ListKeysResponse extends Message<ListKeysResponse> {
  /**
   * List of registered keys.
   *
   * @generated from field: repeated com.seed.daemon.v1alpha.NamedKey keys = 1;
   */
  keys: NamedKey[] = [];

  constructor(data?: PartialMessage<ListKeysResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.ListKeysResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "keys", kind: "message", T: NamedKey, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListKeysResponse {
    return new ListKeysResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListKeysResponse {
    return new ListKeysResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListKeysResponse {
    return new ListKeysResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListKeysResponse | PlainMessage<ListKeysResponse> | undefined, b: ListKeysResponse | PlainMessage<ListKeysResponse> | undefined): boolean {
    return proto3.util.equals(ListKeysResponse, a, b);
  }
}

/**
 * Request to change the key name.
 *
 * @generated from message com.seed.daemon.v1alpha.UpdateKeyRequest
 */
export class UpdateKeyRequest extends Message<UpdateKeyRequest> {
  /**
   * Current name of the key.
   *
   * @generated from field: string current_name = 1;
   */
  currentName = "";

  /**
   * New name for the key.
   *
   * @generated from field: string new_name = 2;
   */
  newName = "";

  constructor(data?: PartialMessage<UpdateKeyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.UpdateKeyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "current_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateKeyRequest {
    return new UpdateKeyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateKeyRequest {
    return new UpdateKeyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateKeyRequest {
    return new UpdateKeyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateKeyRequest | PlainMessage<UpdateKeyRequest> | undefined, b: UpdateKeyRequest | PlainMessage<UpdateKeyRequest> | undefined): boolean {
    return proto3.util.equals(UpdateKeyRequest, a, b);
  }
}

/**
 * Request to delete an existing key.
 *
 * @generated from message com.seed.daemon.v1alpha.DeleteKeyRequest
 */
export class DeleteKeyRequest extends Message<DeleteKeyRequest> {
  /**
   * Name of the key to delete.
   *
   * @generated from field: string name = 1;
   */
  name = "";

  constructor(data?: PartialMessage<DeleteKeyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.DeleteKeyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteKeyRequest {
    return new DeleteKeyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteKeyRequest {
    return new DeleteKeyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteKeyRequest {
    return new DeleteKeyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteKeyRequest | PlainMessage<DeleteKeyRequest> | undefined, b: DeleteKeyRequest | PlainMessage<DeleteKeyRequest> | undefined): boolean {
    return proto3.util.equals(DeleteKeyRequest, a, b);
  }
}

/**
 * Request to store blobs.
 *
 * @generated from message com.seed.daemon.v1alpha.StoreBlobsRequest
 */
export class StoreBlobsRequest extends Message<StoreBlobsRequest> {
  /**
   * Required. List of blobs to be stored.
   * The request is atomic: either all blobs are stored or none of them.
   *
   * @generated from field: repeated com.seed.daemon.v1alpha.Blob blobs = 1;
   */
  blobs: Blob[] = [];

  constructor(data?: PartialMessage<StoreBlobsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.StoreBlobsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "blobs", kind: "message", T: Blob, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StoreBlobsRequest {
    return new StoreBlobsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StoreBlobsRequest {
    return new StoreBlobsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StoreBlobsRequest {
    return new StoreBlobsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StoreBlobsRequest | PlainMessage<StoreBlobsRequest> | undefined, b: StoreBlobsRequest | PlainMessage<StoreBlobsRequest> | undefined): boolean {
    return proto3.util.equals(StoreBlobsRequest, a, b);
  }
}

/**
 * Response after storing blobs.
 *
 * @generated from message com.seed.daemon.v1alpha.StoreBlobsResponse
 */
export class StoreBlobsResponse extends Message<StoreBlobsResponse> {
  /**
   * List of CIDs for the stored blobs.
   * The order is the same as in the request.
   *
   * @generated from field: repeated string cids = 1;
   */
  cids: string[] = [];

  constructor(data?: PartialMessage<StoreBlobsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.StoreBlobsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StoreBlobsResponse {
    return new StoreBlobsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StoreBlobsResponse {
    return new StoreBlobsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StoreBlobsResponse {
    return new StoreBlobsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StoreBlobsResponse | PlainMessage<StoreBlobsResponse> | undefined, b: StoreBlobsResponse | PlainMessage<StoreBlobsResponse> | undefined): boolean {
    return proto3.util.equals(StoreBlobsResponse, a, b);
  }
}

/**
 * Request to sign data.
 *
 * @generated from message com.seed.daemon.v1alpha.SignDataRequest
 */
export class SignDataRequest extends Message<SignDataRequest> {
  /**
   * Required. Name of the signing key to use for signing.
   *
   * @generated from field: string signing_key_name = 1;
   */
  signingKeyName = "";

  /**
   * Required. Data to be signed.
   *
   * @generated from field: bytes data = 2;
   */
  data = new Uint8Array(0);

  constructor(data?: PartialMessage<SignDataRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.SignDataRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "signing_key_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignDataRequest {
    return new SignDataRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignDataRequest {
    return new SignDataRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignDataRequest {
    return new SignDataRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SignDataRequest | PlainMessage<SignDataRequest> | undefined, b: SignDataRequest | PlainMessage<SignDataRequest> | undefined): boolean {
    return proto3.util.equals(SignDataRequest, a, b);
  }
}

/**
 * Response for signing data.
 *
 * @generated from message com.seed.daemon.v1alpha.SignDataResponse
 */
export class SignDataResponse extends Message<SignDataResponse> {
  /**
   * Signature over the data.
   *
   * @generated from field: bytes signature = 1;
   */
  signature = new Uint8Array(0);

  constructor(data?: PartialMessage<SignDataResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.SignDataResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "signature", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignDataResponse {
    return new SignDataResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignDataResponse {
    return new SignDataResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignDataResponse {
    return new SignDataResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SignDataResponse | PlainMessage<SignDataResponse> | undefined, b: SignDataResponse | PlainMessage<SignDataResponse> | undefined): boolean {
    return proto3.util.equals(SignDataResponse, a, b);
  }
}

/**
 * Address information about a single peer.
 *
 * @generated from message com.seed.daemon.v1alpha.AddrInfo
 */
export class AddrInfo extends Message<AddrInfo> {
  /**
   * @generated from field: string peer_id = 1;
   */
  peerId = "";

  /**
   * @generated from field: repeated string addrs = 2;
   */
  addrs: string[] = [];

  constructor(data?: PartialMessage<AddrInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.AddrInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "peer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "addrs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddrInfo {
    return new AddrInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddrInfo {
    return new AddrInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddrInfo {
    return new AddrInfo().fromJsonString(jsonString, options);
  }

  static equals(a: AddrInfo | PlainMessage<AddrInfo> | undefined, b: AddrInfo | PlainMessage<AddrInfo> | undefined): boolean {
    return proto3.util.equals(AddrInfo, a, b);
  }
}

/**
 * Raw blob to be stored.
 *
 * @generated from message com.seed.daemon.v1alpha.Blob
 */
export class Blob extends Message<Blob> {
  /**
   * Optional. The client can provide a CID for the blob (the server will verify it).
   * If not provided, the data is assumed to be DAG-CBOR encoded, and the server will generate a CID
   * using its default hash function.
   *
   * @generated from field: string cid = 1;
   */
  cid = "";

  /**
   * Required. Raw data of the blob.
   *
   * @generated from field: bytes data = 2;
   */
  data = new Uint8Array(0);

  constructor(data?: PartialMessage<Blob>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.Blob";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Blob {
    return new Blob().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Blob {
    return new Blob().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Blob {
    return new Blob().fromJsonString(jsonString, options);
  }

  static equals(a: Blob | PlainMessage<Blob> | undefined, b: Blob | PlainMessage<Blob> | undefined): boolean {
    return proto3.util.equals(Blob, a, b);
  }
}

/**
 * Info is a generic information about the running node.
 *
 * @generated from message com.seed.daemon.v1alpha.Info
 */
export class Info extends Message<Info> {
  /**
   * Current state of the daemon.
   *
   * @generated from field: com.seed.daemon.v1alpha.State state = 1;
   */
  state = State.STARTING;

  /**
   * Libp2p Peer ID of this node.
   *
   * @generated from field: string peer_id = 2;
   */
  peerId = "";

  /**
   * Start time of the node.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * The libp2p protocol ID that the daemon is using.
   *
   * @generated from field: string protocol_id = 4;
   */
  protocolId = "";

  /**
   * The tasks that the daemon is currently performing.
   *
   * @generated from field: repeated com.seed.daemon.v1alpha.Task tasks = 5;
   */
  tasks: Task[] = [];

  constructor(data?: PartialMessage<Info>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.Info";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "state", kind: "enum", T: proto3.getEnumType(State) },
    { no: 2, name: "peer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "start_time", kind: "message", T: Timestamp },
    { no: 4, name: "protocol_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "tasks", kind: "message", T: Task, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Info {
    return new Info().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Info {
    return new Info().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Info {
    return new Info().fromJsonString(jsonString, options);
  }

  static equals(a: Info | PlainMessage<Info> | undefined, b: Info | PlainMessage<Info> | undefined): boolean {
    return proto3.util.equals(Info, a, b);
  }
}

/**
 * VaultSyncStatus describes daemon sync metadata for vault state.
 *
 * @generated from message com.seed.daemon.v1alpha.VaultSyncStatus
 */
export class VaultSyncStatus extends Message<VaultSyncStatus> {
  /**
   * Last local vault version known by the daemon.
   *
   * @generated from field: int64 local_version = 1;
   */
  localVersion = protoInt64.zero;

  /**
   * Last remote vault version observed by the daemon.
   *
   * @generated from field: int64 remote_version = 2;
   */
  remoteVersion = protoInt64.zero;

  /**
   * Last successful or attempted sync time.
   *
   * @generated from field: google.protobuf.Timestamp last_sync_time = 3;
   */
  lastSyncTime?: Timestamp;

  /**
   * Last sync error message, when sync failed.
   *
   * @generated from field: string last_sync_error = 4;
   */
  lastSyncError = "";

  constructor(data?: PartialMessage<VaultSyncStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.VaultSyncStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "local_version", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "remote_version", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "last_sync_time", kind: "message", T: Timestamp },
    { no: 4, name: "last_sync_error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VaultSyncStatus {
    return new VaultSyncStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VaultSyncStatus {
    return new VaultSyncStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VaultSyncStatus {
    return new VaultSyncStatus().fromJsonString(jsonString, options);
  }

  static equals(a: VaultSyncStatus | PlainMessage<VaultSyncStatus> | undefined, b: VaultSyncStatus | PlainMessage<VaultSyncStatus> | undefined): boolean {
    return proto3.util.equals(VaultSyncStatus, a, b);
  }
}

/**
 * Response with daemon vault backend mode, remote status, and sync metadata.
 *
 * @generated from message com.seed.daemon.v1alpha.GetVaultStatusResponse
 */
export class GetVaultStatusResponse extends Message<GetVaultStatusResponse> {
  /**
   * Current daemon vault backend mode.
   *
   * @generated from field: com.seed.daemon.v1alpha.VaultBackendMode backend_mode = 1;
   */
  backendMode = VaultBackendMode.UNSPECIFIED;

  /**
   * Current remote connection status.
   *
   * @generated from field: com.seed.daemon.v1alpha.VaultConnectionStatus connection_status = 2;
   */
  connectionStatus = VaultConnectionStatus.UNSPECIFIED;

  /**
   * Remote vault URL when in remote mode.
   *
   * @generated from field: string remote_vault_url = 3;
   */
  remoteVaultUrl = "";

  /**
   * Sync status metadata.
   *
   * @generated from field: com.seed.daemon.v1alpha.VaultSyncStatus sync_status = 4;
   */
  syncStatus?: VaultSyncStatus;

  constructor(data?: PartialMessage<GetVaultStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.GetVaultStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "backend_mode", kind: "enum", T: proto3.getEnumType(VaultBackendMode) },
    { no: 2, name: "connection_status", kind: "enum", T: proto3.getEnumType(VaultConnectionStatus) },
    { no: 3, name: "remote_vault_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sync_status", kind: "message", T: VaultSyncStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetVaultStatusResponse {
    return new GetVaultStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetVaultStatusResponse {
    return new GetVaultStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetVaultStatusResponse {
    return new GetVaultStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetVaultStatusResponse | PlainMessage<GetVaultStatusResponse> | undefined, b: GetVaultStatusResponse | PlainMessage<GetVaultStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetVaultStatusResponse, a, b);
  }
}

/**
 * Description of a task that the daemon is performing.
 *
 * @generated from message com.seed.daemon.v1alpha.Task
 */
export class Task extends Message<Task> {
  /**
   * Name of the task.
   *
   * @generated from field: com.seed.daemon.v1alpha.TaskName task_name = 1;
   */
  taskName = TaskName.TASK_NAME_UNSPECIFIED;

  /**
   * Description of the task.
   *
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * Total amount of work for the task.
   *
   * @generated from field: int64 total = 3;
   */
  total = protoInt64.zero;

  /**
   * Amount of work completed. Always less than or equal to total.
   *
   * @generated from field: int64 completed = 4;
   */
  completed = protoInt64.zero;

  constructor(data?: PartialMessage<Task>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.Task";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_name", kind: "enum", T: proto3.getEnumType(TaskName) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "completed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Task {
    return new Task().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Task {
    return new Task().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Task {
    return new Task().fromJsonString(jsonString, options);
  }

  static equals(a: Task | PlainMessage<Task> | undefined, b: Task | PlainMessage<Task> | undefined): boolean {
    return proto3.util.equals(Task, a, b);
  }
}

/**
 * Signing key with an internal name.
 *
 * @generated from message com.seed.daemon.v1alpha.NamedKey
 */
export class NamedKey extends Message<NamedKey> {
  /**
   * Public key in Multikey format.
   * https://www.w3.org/TR/vc-data-integrity/#multikey.
   *
   * @generated from field: string public_key = 1;
   */
  publicKey = "";

  /**
   * Private name for the key. Useful to identify the keys when there're more than one.
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * Account ID representation of this key.
   *
   * @generated from field: string account_id = 3;
   */
  accountId = "";

  constructor(data?: PartialMessage<NamedKey>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.NamedKey";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "public_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NamedKey {
    return new NamedKey().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NamedKey {
    return new NamedKey().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NamedKey {
    return new NamedKey().fromJsonString(jsonString, options);
  }

  static equals(a: NamedKey | PlainMessage<NamedKey> | undefined, b: NamedKey | PlainMessage<NamedKey> | undefined): boolean {
    return proto3.util.equals(NamedKey, a, b);
  }
}

/**
 * Request to get domain info.
 *
 * @generated from message com.seed.daemon.v1alpha.GetDomainRequest
 */
export class GetDomainRequest extends Message<GetDomainRequest> {
  /**
   * Required. The domain name (e.g. "hyper.media").
   *
   * @generated from field: string domain = 1;
   */
  domain = "";

  constructor(data?: PartialMessage<GetDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.GetDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDomainRequest {
    return new GetDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDomainRequest {
    return new GetDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDomainRequest {
    return new GetDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDomainRequest | PlainMessage<GetDomainRequest> | undefined, b: GetDomainRequest | PlainMessage<GetDomainRequest> | undefined): boolean {
    return proto3.util.equals(GetDomainRequest, a, b);
  }
}

/**
 * Request to list tracked domains.
 *
 * @generated from message com.seed.daemon.v1alpha.ListDomainsRequest
 */
export class ListDomainsRequest extends Message<ListDomainsRequest> {
  constructor(data?: PartialMessage<ListDomainsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.ListDomainsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDomainsRequest {
    return new ListDomainsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDomainsRequest {
    return new ListDomainsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDomainsRequest {
    return new ListDomainsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDomainsRequest | PlainMessage<ListDomainsRequest> | undefined, b: ListDomainsRequest | PlainMessage<ListDomainsRequest> | undefined): boolean {
    return proto3.util.equals(ListDomainsRequest, a, b);
  }
}

/**
 * Response with the list of tracked domains.
 *
 * @generated from message com.seed.daemon.v1alpha.ListDomainsResponse
 */
export class ListDomainsResponse extends Message<ListDomainsResponse> {
  /**
   * List of tracked domains.
   *
   * @generated from field: repeated com.seed.daemon.v1alpha.DomainInfo domains = 1;
   */
  domains: DomainInfo[] = [];

  constructor(data?: PartialMessage<ListDomainsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.ListDomainsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domains", kind: "message", T: DomainInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDomainsResponse {
    return new ListDomainsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDomainsResponse {
    return new ListDomainsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDomainsResponse {
    return new ListDomainsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDomainsResponse | PlainMessage<ListDomainsResponse> | undefined, b: ListDomainsResponse | PlainMessage<ListDomainsResponse> | undefined): boolean {
    return proto3.util.equals(ListDomainsResponse, a, b);
  }
}

/**
 * Request to add a domain to track.
 *
 * @generated from message com.seed.daemon.v1alpha.AddDomainRequest
 */
export class AddDomainRequest extends Message<AddDomainRequest> {
  /**
   * Required. The domain name (e.g. "hyper.media").
   *
   * @generated from field: string domain = 1;
   */
  domain = "";

  constructor(data?: PartialMessage<AddDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.AddDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddDomainRequest {
    return new AddDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddDomainRequest {
    return new AddDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddDomainRequest {
    return new AddDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AddDomainRequest | PlainMessage<AddDomainRequest> | undefined, b: AddDomainRequest | PlainMessage<AddDomainRequest> | undefined): boolean {
    return proto3.util.equals(AddDomainRequest, a, b);
  }
}

/**
 * Request to remove a tracked domain.
 *
 * @generated from message com.seed.daemon.v1alpha.RemoveDomainRequest
 */
export class RemoveDomainRequest extends Message<RemoveDomainRequest> {
  /**
   * Required. The domain name to remove.
   *
   * @generated from field: string domain = 1;
   */
  domain = "";

  constructor(data?: PartialMessage<RemoveDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.RemoveDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemoveDomainRequest {
    return new RemoveDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemoveDomainRequest {
    return new RemoveDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemoveDomainRequest {
    return new RemoveDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RemoveDomainRequest | PlainMessage<RemoveDomainRequest> | undefined, b: RemoveDomainRequest | PlainMessage<RemoveDomainRequest> | undefined): boolean {
    return proto3.util.equals(RemoveDomainRequest, a, b);
  }
}

/**
 * Request to force a re-check of a domain.
 *
 * @generated from message com.seed.daemon.v1alpha.CheckDomainRequest
 */
export class CheckDomainRequest extends Message<CheckDomainRequest> {
  /**
   * Required. The domain name to check.
   *
   * @generated from field: string domain = 1;
   */
  domain = "";

  constructor(data?: PartialMessage<CheckDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.CheckDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckDomainRequest {
    return new CheckDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckDomainRequest {
    return new CheckDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckDomainRequest {
    return new CheckDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckDomainRequest | PlainMessage<CheckDomainRequest> | undefined, b: CheckDomainRequest | PlainMessage<CheckDomainRequest> | undefined): boolean {
    return proto3.util.equals(CheckDomainRequest, a, b);
  }
}

/**
 * Information about a tracked domain.
 *
 * @generated from message com.seed.daemon.v1alpha.DomainInfo
 */
export class DomainInfo extends Message<DomainInfo> {
  /**
   * The domain name.
   *
   * @generated from field: string domain = 1;
   */
  domain = "";

  /**
   * Timestamp of the last check.
   *
   * @generated from field: google.protobuf.Timestamp last_check = 2;
   */
  lastCheck?: Timestamp;

  /**
   * Status of the last check: "success", "unreachable", "error", or "unknown".
   *
   * @generated from field: string status = 3;
   */
  status = "";

  /**
   * Timestamp of the last successful check.
   *
   * @generated from field: google.protobuf.Timestamp last_success = 4;
   */
  lastSuccess?: Timestamp;

  /**
   * The registered account UID from the domain's config.
   *
   * @generated from field: string registered_account_uid = 5;
   */
  registeredAccountUid = "";

  /**
   * The peer ID of the domain's node.
   *
   * @generated from field: string peer_id = 6;
   */
  peerId = "";

  /**
   * Error details from the last failed check.
   *
   * @generated from field: string last_error = 7;
   */
  lastError = "";

  constructor(data?: PartialMessage<DomainInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.daemon.v1alpha.DomainInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last_check", kind: "message", T: Timestamp },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_success", kind: "message", T: Timestamp },
    { no: 5, name: "registered_account_uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "peer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "last_error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DomainInfo {
    return new DomainInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DomainInfo {
    return new DomainInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DomainInfo {
    return new DomainInfo().fromJsonString(jsonString, options);
  }

  static equals(a: DomainInfo | PlainMessage<DomainInfo> | undefined, b: DomainInfo | PlainMessage<DomainInfo> | undefined): boolean {
    return proto3.util.equals(DomainInfo, a, b);
  }
}

